// extracted by mini-css-extract-plugin
export default {"add-icon":"DealsFilters_add-icon__JRiEg"};